
import { isSSR } from "@/lib/isSSR";
import ServerBlogPage from "./ServerBlogPage";
import ClientBlogPage from "./ClientBlogPage";

/**
 * Componente Blog che decide quale versione renderizzare in base al contesto
 * - ServerBlogPage: ottimizzato per il rendering lato server e SEO
 * - ClientBlogPage: ottimizzato per l'interattività lato client
 */
const Blog = () => {
  // Utilizza la versione ottimizzata per il server durante il rendering SSR
  if (isSSR()) {
    return <ServerBlogPage />;
  }
  
  // Altrimenti utilizza la versione client con tutte le funzionalità interattive
  return <ClientBlogPage />;
};

export default Blog;
